import { verifyStartAlipayWithhold } from '@/api/domain/finance'
import { operateMaxShowLength } from '@/store/dict/config'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict'


export const config = function () {
  const tableColumns = [
    {
      name: 'billTypeName',
      columnProps: {
        prop: 'billTypeName',
        label: '账单类型',
      },
    },
    {
      name: 'cycleNum',
      columnProps: {
        label: '期数',
        prop: 'cycleNum',
        width: 50,
      },
    },
    {
      name: 'billCycle',
      columnProps: {
        label: '账单周期',
        prop: 'billCycle',
        minWidth: 180,
      },
    },
    {
      name: 'finishOrderCount',
      columnProps: {
        label: '完成单量',
        prop: 'finishOrderCount',
      },
    },
    {
      name: 'amount',
      columnProps: {
        label: '应收金额',
        prop: 'amount',
        minWidth: 80,
      },
    },
    {
      name: 'receivingAmount',
      columnProps: {
        label: '收款中',
        prop: 'receivingAmount',
        minWidth: 80,
      },
    },
    {
      name: 'receivedAmount',
      columnProps: {
        label: '已收款',
        prop: 'receivedAmount',
        minWidth: 80,
      },
    },
    {
      name: 'remainingAmount',
      columnProps: {
        label: '剩余应收',
        prop: 'remainingAmount',
        minWidth: 80,
      },
    },
    {
      name: 'receivableIds',
      columnProps: {
        label: '应收ID',
        prop: 'receivableIds',
      },
      render: ({ row }) => {
        if (row.receivableIds) {
          const ids = row.receivableIds.split(',')
          const len = ids.length - 1
          const arr = []
          ids.forEach((id) => {
            arr.push(
              <div class="a-hover-link" onClick={() => this.$router.push({
                path: `/finance/collection/detail?id=${id}`,
              })}>{`${id}`}</div>,
            )
          })
          return arr
        }
        return '--'
      },
    },
    {
      name: 'receivableStateName',
      columnProps: {
        label: '状态',
        prop: 'receivableStateName',
      },
    },
    {
      name: 'createUser',
      columnProps: {
        label: '创建人',
        prop: 'createUser',
      },
    },
    {
      name: 'createTime',
      columnProps: {
        label: '创建时间',
        prop: 'createTime',
        minWidth: 180,
      },
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        width: 240,
        fixed: 'right',
      },
      maxShowLength: operateMaxShowLength,
      type: 'operate',
      getOperateList: ({ row }) => {
        const result = []
        if (row.receivableIds) {
          result.push({
            name: 'paymentDetail',
            label: '收款详情',
            action: () => this.paymentDetail(row),
          })
        }

        if (row.offlineReceiveFlag
          && row.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
          result.push({
            name: 'offlinePayment',
            label: '线下收款',
            action: () => this.offlinePayment(row),
          })
        }
        if (row.showAlipayWithhold) {
          result.push({
            name: 'alipayWithhold',
            label: '支付宝支付',
            action: async () => {
              const { code, data } = await verifyStartAlipayWithhold({
                orderId: this.$route.query.id,
                receivableIds: row.receivableIds.split(','),
              })
              if (code === 1 && data) {
                this.$refs?.alipayWithholdDialogNewRef.showDialog(
                  this.$route.query.id,
                  row.receivableIds,
                )
              }
            },
          })
        }

        return result
      },
    },
  ]

  return {
    tableColumns,
  }
}

export const receivepaymentDetailConf = function () {
  const tableColumns = [
    {
      name: 'id',
      columnProps: {
        prop: 'id',
        label: '收款单ID',
        minWidth: 100,
      },
    },
    {
      name: 'amount',
      columnProps: {
        prop: 'amount',
        label: '收款金额',
        minWidth: 100,
      },
    },
    {
      name: 'payMethodName',
      columnProps: {
        prop: 'payMethodName',
        label: '收款方式',
        minWidth: 100,
      },
    },
    {
      name: 'stateName',
      columnProps: {
        prop: 'stateName',
        label: '收款单状态',
        minWidth: 100,
      },
    },
    {
      name: 'gmtCreate',
      columnProps: {
        prop: 'gmtCreate',
        label: '创建时间',
        minWidth: 180,
      },
    },
    {
      name: 'completeTime',
      columnProps: {
        prop: 'completeTime',
        label: '完成时间',
        minWidth: 180,
      },
    },
  ]
  return {
    tableColumns,
  }
}
